/*
 * Adoorn Pillar Articles Hydrator (v2)
 * Reads server-rendered article data from <script id="adn-blog-articles" type="application/json"> 
 * (injected by theme.liquid via Liquid). Populates any .articles-grid[data-blog-handle] on the page.
 * Sorted by published date, newest first.
 */
(function () {
  if (typeof window === 'undefined') return;
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }
  function readData() {
    var node = document.getElementById('adn-blog-articles');
    if (!node) return null;
    try { return JSON.parse(node.textContent || node.innerText || '{}'); }
    catch (e) { console.warn('[pillar] data island parse error', e); return null; }
  }
  function readTime(text) {
    var w = (text || '').split(/\s+/).filter(Boolean).length;
    return Math.max(2, Math.round(w / 220)) + ' min read';
  }
  function buildCard(a) {
    var img = a.image || '';
    var tag = a.tag || '';
    var meta = readTime(a.summary || a.excerpt || '');
    return (
      '<a href="' + esc(a.url) + '" class="article-card">' +
        '<div class="article-image">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(a.title) + '" loading="lazy">' : '') +
          (tag ? '<span class="article-tag">' + esc(tag) + '</span>' : '') +
        '</div>' +
        '<div class="article-body">' +
          '<h3>' + esc(a.title) + '</h3>' +
          (a.summary ? '<p>' + esc(a.summary) + '</p>' : '') +
          '<span class="article-meta">' + esc(meta) + '</span>' +
        '</div>' +
      '</a>'
    );
  }
  function hydrate(grid, data) {
    var handle = grid.getAttribute('data-blog-handle');
    var limit = parseInt(grid.getAttribute('data-limit') || '24', 10);
    if (!handle || !data || !data[handle]) return;
    var articles = data[handle].slice(0).sort(function (a, b) {
      return new Date(b.published || 0) - new Date(a.published || 0);
    }).slice(0, limit);
    if (!articles.length) return;
    grid.innerHTML = articles.map(buildCard).join('\n');
  }
  function run() {
    var data = readData();
    if (!data) return;
    var grids = document.querySelectorAll('.articles-grid[data-blog-handle]');
    if (!grids.length) return;
    grids.forEach(function (g) { hydrate(g, data); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
